<template>
  <div class="time_progress">
    <IEcharts
      :option="option"
      :resizable="true"
      @ready="onReady"
      :style="pWidth"
    />
  </div>
</template>

<script>

export default {
  name: 'TimeProgressCard',
  props: ['info', 'status', 'period', 'width'],
  data () {
    return {
      ins: null,
      echarts: null
    }
  },
  computed: {
    info_2 () {
      var data = []
      let start, end
      for (let i in this.info) {
        start = this.info[i]['ts_start'] * 1000
        end = this.info[i]['ts_end'] * 1000
        data.push({
          value: [
            0,
            start,
            end,
            end - start
          ],
          itemStyle: {
            color: '#75d874'
          }
        })
      }
      return data
    },
    option () {
      if (!this.status) {
        return {}
      }
      let that = this, period = that.period
      return {
        tooltip: {
          formatter:function (params) {
            let tsStart = new Date(params.value[1])
            let tsEnd = new Date(params.value[2])
            return period + ' ' + ('0' + tsStart.getHours()).slice(-2) + ':' + ('0' + tsStart.getMinutes()).slice(-2) + ' - ' + ('0' + tsEnd.getHours()).slice(-2) + ':' + ('0' + tsEnd.getMinutes()).slice(-2)
          }
        },
        grid: {
          height: 10,
          top: 0,
          left: '5%',
          rigth: '5%',
          width: '90%'
        },
        xAxis: {
          scale: true,
          type: 'time',
          axisLabel: {
            formatter: function (val) {
              let date = new Date(val)
              return ('0' + date.getHours()).slice(-2) + ':' + ('0' + date.getMinutes()).slice(-2)
            }
          }
        },
        yAxis: {
          show: false,
          data: ['time']
        },
        series: [{
          type: 'custom',
          renderItem: this.renderItem,
          encode: {
            x: [1, 2],
            y: 0
          },
          data: this.info_2
        }]
      }
    },
    pWidth(){
      return parseFloat(this.width*0.95) + 'px'
    }
  },
  methods: {
    formatFunction(params){
      const param = params[0];
      var date = new Date(param.value[0]);
      return date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear() + ' : ' + param.value[1];
    },
    onReady (instance, echarts) {
      const that = this
      that.ins = instance
      that.echarts = echarts
    },
    updatePosition () {
      if (this.ins.resize !== undefined || this.ins.resize !== null) {
        this.ins.resize()
      }
    },
    renderItem (params, api) {
      var categoryIndex = api.value(0)
      var start = api.coord([api.value(1), categoryIndex])
      var end = api.coord([api.value(2), categoryIndex])
      var height = api.size([0, 1])[1] * 0.6

      return {
        type: 'rect',
        shape: this.echarts.graphic.clipRectByRect({
          x: start[0],
          y: start[1] - height / 2,
          width: end[0] - start[0],
          height: height
        }, {
          x: params.coordSys.x,
          y: params.coordSys.y,
          width: params.coordSys.width,
          height: params.coordSys.height
        }),
        style: api.style()
      }
    }
  }
}
</script>
<style>
  .time_progress {
    height: 30px;
    margin: 0 auto;
    width: 100%;
  }
</style>
